import {Component, OnInit, Input} from '@angular/core';
import {RouteService} from '../../shared/services/route.service';
import {FormControl, FormGroup} from '@angular/forms';
import {DataStorageService} from '../../shared/services/data-storage.service';
import {DispatchGroup} from '../../shared/models/dispatchGroup.model';

const now = new Date();

@Component({
    selector: 'form-edit-dispatch-group',
    templateUrl: 'form-edit-dispatch-group.html',
    styleUrls: ['../../../assets/scss/plugins/_datepicker.scss']
})

export class FormEditDispatchGroupComponent implements OnInit {
    constructor(
        private routeService: RouteService,
        private dataStorageService: DataStorageService) {
    }

    @Input() dispatchGroup: DispatchGroup;
    dispatchGroupForm: FormGroup;

    ngOnInit() {
        this.initForm();
    }

    initForm() {
        this.dispatchGroupForm = new FormGroup({
            'title': new FormControl(this.dispatchGroup.title),
            'icon': new FormControl(this.dispatchGroup.icon)
        });
    }

    onEditDispatchGroup() {
        const value = this.dispatchGroupForm.value;
        const newDispatchGroup = new DispatchGroup(this.dispatchGroup.id, value.title, value.icon, this.dispatchGroup.created);
        this.dataStorageService.updateDispatchGroup(newDispatchGroup);
    }

}
